// extracted by mini-css-extract-plugin
export default {"section":"Title_section__-b4gM","h1":"Title_h1__UE9G5"};